const getConfigurationInfoResponse = (response) => {
    const trxCode = response?.trx_code?.map((item) => ({
        id: item.transfer_type ?? item.id,
        name: item.transfer_type ?? item.id,
    }));

    return {
        ...response,
        ...(trxCode && trxCode.length > 0 && { trx_code: trxCode }),
    };
};

export default getConfigurationInfoResponse;
